import React from 'react';

export const Btn = (props) => (
  <div className="btn-border-rounded-full">
    <p className="align-center">{props.content}</p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/reusable/btn/index.js